import NewsTipContext from './NewsTipContext'
import { useContext } from 'react'

const useNewsTip = () => useContext(NewsTipContext)

export default useNewsTip
